export default "__VITE_ASSET__3ETp5kTl__"